<template>
  <div>
    <div class="pa-3">
      <v-layout
        wrap
        style="border: 1px solid grey; border-radius: 5px"
        class="pa-3"
      >
        <v-flex xs12 sm6 class="pa-1">
          <v-text-field
            v-model="searchForm.searchedCode"
            label="Search Reference source"
          ></v-text-field
        ></v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <v-text-field
            v-model="searchForm.searchedName"
            label="Search Reference name"
          ></v-text-field></v-flex
        ><v-flex xs12 sm6 class="pa-1">
          <v-text-field
            v-model="searchForm.searchedWalletAddress"
            label="Search wallet address"
          ></v-text-field
        ></v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <v-text-field
            v-model="searchForm.searchedType"
            label="Search type"
          ></v-text-field
        ></v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <v-select
            :items="filterList"
            item-text="name"
            item-value="value"
            v-model="searchForm.filterStatus"
          ></v-select></v-flex
      ></v-layout>
    </div>
    <v-data-table
      :headers="headers"
      :items="searchQueueList"
      item-key="queue_id"
      :isLoading="isLoading"
      :rows-per-page-items="[10, 50]"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            {{ queueList.indexOf(props.item) + 1 }}
          </td>
          <td class="text-xs-center">
            {{ props.item.queue_type }}
          </td>

          <td>
            {{ props.item.queue_user_wallet_address }}
          </td>

          <td style="color: red; white-space: nowrap" class="text-xs-center">
            <span v-if="props.item.queue_amount_point > 0">
              - {{ props.item.queue_amount_point }}</span
            >
            <span v-else style="color: grey">{{
              props.item.queue_amount_point
            }}</span>
          </td>
          <td style="color: green; white-space: nowrap" class="text-xs-center">
            <span v-if="props.item.queue_type == 'withdraw'" style="color: red">
              - {{ props.item.queue_amount_token }}</span
            >
            <span v-else> + {{ props.item.queue_amount_token }}</span>
          </td>
          <td
            class="text-xs-center"
            :style="{
              color:
                props.item.queue_status == 1
                  ? 'orange'
                  : props.item.queue_status == 2
                  ? 'green'
                  : props.item.queue_status == 3
                  ? 'red'
                  : props.item.queue_status == 4
                  ? 'purple'
                  : '',
            }"
          >
            {{
              props.item.queue_status == 1
                ? "Pending"
                : props.item.queue_status == 2
                ? "Success"
                : props.item.queue_status == 3
                ? "Failed"
                : props.item.queue_status == 4
                ? "Canceled"
                : ""
            }}
          </td>
          <td class="text-xs-center">
            {{ props.item.queue_name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.queue_code }}
          </td>
          <td class="text-xs-center">
            <v-btn
              v-if="
                props.item.queue_status == 1 || props.item.queue_status == 3
              "
              :loading="isCanceling.includes(props.item.queue_id)"
              @click="cancelQueue(props.item)"
              color="red"
              style="color: white"
            >
              cancel
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: [
    "isLoading",
    "searchForm",
    "filterList",
    "searchQueueList",
    "headers",
    "queueList",
  ],
  data() {
    return {
      // viewDialog: false,
      // isLoadingDetail: false,
      isCanceling: [],
    };
  },
  computed: {},
  methods: {
    ...mapActions({
      cancelTokenQueue: "crypto/cancelTokenQueue",
    }),
    async cancelQueue(item) {
      let n = await this.$confirm("Do you want to cancel this queue ?");
      if (n == true) {
        this.isCanceling.push(item.queue_id);
        await this.cancelTokenQueue(item.queue_id);
        let index = this.isCanceling.findIndex((val) => val == item.queue_id);
        this.isCanceling.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped>
.dialogcontent--title {
  font-size: 22px;
  text-decoration: underline;
  padding-bottom: 16px;
}
.dialogcontent--subtitle {
  font-size: 20px;
}

.dialogcontent--value {
  font-size: 18px;
  color: grey;
}

.spinner {
  width: 40px;
  height: 40px;
  background-color: #333;

  margin: 20px auto;
  -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
  animation: sk-rotateplane 1.2s infinite ease-in-out;
}

@-webkit-keyframes sk-rotateplane {
  0% {
    -webkit-transform: perspective(120px);
  }
  50% {
    -webkit-transform: perspective(120px) rotateY(180deg);
  }
  100% {
    -webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg);
  }
}

@keyframes sk-rotateplane {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }
  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}
</style>
